interface SessionDetailsInfoProps {
  title: string;
  time: string;
  borderColorVariant?: 'aqua' | 'orange' | 'red';
}

export const SessionDetailsInfo = ({
  title,
  time,
  borderColorVariant: variant = 'aqua',
}: SessionDetailsInfoProps) => {
  
  return (
    <div className={`session-details-info border-${variant}`}>
      <p className="line-clamp-1">{title}</p>
      <div className="flex flex-wrap gap-2 md:min-w-[130px] md:flex-col md:gap-0">
        <p className="text-grey-30 dark:text-grey-70 border-r-grey-70 line-clamp-1 min-w-[80px] pl-5 border-r pr-2 text-sm last:border-r-0 md:border-r-0 md:pr-0 md:pl-8">
          {time}
        </p>
      </div>
    </div>
  );
};
